<ng-container *ngIf="vo$ | async; let vo">
	<app-page>
		<app-page-header>
			<app-breadcrumb [paths]="paths"></app-breadcrumb>
		</app-page-header>

		<app-page-content>
			<div class="subscription-simulator">
				<app-card-outline class="subscription-simulator__metadata">
					<div card-outline-content class="metadata-card">
						<h3
							[matTooltip]="vo.simulationMetadata.title"
							[matTooltipDisabled]="vo.simulationMetadata.title.length <= Configuration.maxLengthSubPublicMetadataTitleDisplay"
							matTooltipPosition="right">
							{{ vo.simulationMetadata.title | truncate: Configuration.maxLengthSubPublicMetadataTitleDisplay : 1 : 'end' }}</h3>

						<div class="metadata-card__timeline">
							<app-chip
								*ngIf="vo.simulationMetadata.creationDate">
								<mat-icon
									[svgIcon]="DcIcons.Share"
									app-chip-icon></mat-icon>
								<span>
									{{ vo.simulationMetadata.creationDate | dayjsDate: 'DateTime' }}</span>
							</app-chip>
							<app-chip
								*ngIf="vo.simulationMetadata.updateDate">
								<mat-icon
									[svgIcon]="DcIcons.Update"
									app-chip-icon></mat-icon>
								<span>
									{{ vo.simulationMetadata.updateDate | dayjsDate: 'DateTime' }}</span>
							</app-chip>
						</div>

						<span
							[matTooltip]="vo.simulationMetadata.description"
							[matTooltipDisabled]="vo.simulationMetadata.description.length <= 120"
							matTooltipPosition="right">
							{{ vo.simulationMetadata.description | truncate: 120 : 2 : 'end'}}</span>

						<div class="metadata-card__keywords" [class.no-selection]="true">
							<div
								class="keywords-chips"
								*ngIf="vo.simulationMetadata.keywords.size !== 0">
								<app-chip
									*ngFor="let keyword of vo.simulationMetadata.keywords | toArray">
									<span>{{ keyword.label }}</span>
								</app-chip>
							</div>
							<div
								*ngIf="vo.simulationMetadata.keywords.size === 0"
								class="keywords-area">
							</div>
						</div>

					</div>
				</app-card-outline>

				<app-panel
					class="subscription-simulator__type"
					[isAlwaysOpen]="true">
					<div
						class="app-panel__title"
						panel-title>
						<span
							i18n="@@subscription.simulator.sim-type">
							sim-type</span>
					</div>

					<div class="simulation-type__content">
						<app-toggle-buttons
							id="simulation-type"
							class="type-selector"
							[actions]="simulateTypeOptions"></app-toggle-buttons>

						<div class="sim-elements"
								 [class.no-selection]="vo.selectedSimElements.size === 0">
							<div class="element-selection-chips">
								<app-chip
									*ngFor="let item of vo.selectedSimElements | toArray"
									viewMode="readOnly"
									cdk-overlay-origin #overlayTrigger="cdkOverlayOrigin"
									[class.filter-chip]="item.type === 'FILTER_MODEL'"
									(click)="openOverlay($event, item)">

									<mat-icon
											*ngIf="item.type === 'COLUMN_MODEL'"
											[svgIcon]="DcIcons.Column" app-chip-icon></mat-icon>

									<mat-icon
											*ngIf="item.type === 'FILTER_MODEL'"
											[svgIcon]="DcIcons.Filter" app-chip-icon></mat-icon>

									<mat-icon
											*ngIf="item.type === 'PROFILE'"
											[svgIcon]="DcIcons.Profile" app-chip-icon></mat-icon>


									<span>{{item.label}}</span>

									<ng-template
										cdkConnectedOverlay
										(overlayOutsideClick)="closeOverlays()"
										[cdkConnectedOverlayOrigin]="overlayTrigger"
										[cdkConnectedOverlayOpen]="vo.openedOverlayFilterModel.filterModelId === item.id">

										<div class="filter-model__details">
											<div class="header">
												<span>{{ item.label }}</span>
												<mat-icon [svgIcon]="DcIcons.Close" (click)="closeOverlays()"></mat-icon>
											</div>

											<div class="query-view">
												<dcds-query-view
													[fields]="vo.availableFields"
													[query]="vo.openedOverlayFilterModel.query"></dcds-query-view>
											</div>
										</div>
									</ng-template>
								</app-chip>
							</div>

							<dc-alert
								*ngIf="vo.selectedSimElements.size === 0"
								type="info"
								message="You should select profile or models"
								i18n-message="@@subscription.simulator.sim-type.select.info">
							</dc-alert>
						</div>

						<app-button
							*ngIf="vo.simulationType !== 'NONE'"
							class="selection-btn"
							loaderSize="20"
							(click)="select()"
							i18n="@@subscription.simulator.select.btn">
							select
						</app-button>
					</div>
				</app-panel>

				<ng-container>
					<app-panel
						class="subscription-simulator__columns"
						[isAlwaysOpen]="true"
						[itemsCount]="vo.simulationColumnList.elements.size">
						<div
							class="app-panel__title"
							panel-title>
							<mat-icon [svgIcon]="ComponentIcons.Column"></mat-icon>
							<span
								i18n="@@subscription.simulator.column.list.title">
								columns</span>
						</div>

						<ng-container
							[ngTemplateOutlet]="simulationColumns"
							[ngTemplateOutletContext]="{ columnList: vo.simulationColumnList }"></ng-container>

						<ng-container
							*ngIf="vo.simulationColumnList.elements.size === 0"
							[ngTemplateOutlet]="noData"></ng-container>

					</app-panel>

					<app-panel
						class="subscription-simulator__query-params"
						[isAlwaysOpen]="true">
						<div
							class="app-panel__title"
							panel-title>
							<!--
								<mat-icon
									[svgIcon]="DcIcons.Filter">
								</mat-icon>
							-->
							<span
								i18n="@@subscription.simulator.queryParams">
								query-params</span>
						</div>

						<div class="columns-area">
							<app-multi-select-menu
								#ColumnsMultiSelectMenu
								maxOptionLength="30"
								[displayedOptions]="vo.columnOptions | toArray"
								[mode]="'type'"
								hasMultiSelection="true"
								(selectedIds)="selectedColumns($event)"
								label="columns"
								i18n-label="@@subscription.simulator.queryParams.columns">
							</app-multi-select-menu>

							<div class="remove-btn">
								<app-button
									*ngIf="vo.selectedColumns.size !== 0"
									loaderSize="20"
									[leftIcon]="DcIcons.ResetSelection"
									(click)="removeAllSelectedColumns()"></app-button>
							</div>

							<div class="select-columns"
									 [class.no-selection]="vo.selectedColumns.size === 0"
									 (click)="vo.selectedColumns.size === 0 && showColumnsMultiSelectMenu($event)">
								<app-columns-configurator
									*ngIf="vo.selectedColumns.size !== 0"
									(handleRemove)="columnRemoved($event)"
									(handleColumnsOrderingChange)="columnOrderModified($event)"
									class="columns-selection-chips"
									[elements]="vo.selectedColumns | toArray"
									[viewMode]="'dragDrop'"></app-columns-configurator>
								<div
									*ngIf="vo.selectedColumns.size === 0"
									class="columns-selection-area"
									i18n="@@subscription.simulator.queryParams.columns.no-selection">
									columns-no-selection
								</div>
							</div>
						</div>

						<div class="sorting-columns-area">
							<app-multi-select-menu
								#SortColumnsMultiSelectMenu
								maxOptionLength="30"
								[displayedOptions]="vo.sortColumnOptions | toArray"
								[mode]="'type'"
								hasMultiSelection="true"
								(selectedIds)="sortSelectedColumns($event)"
								label="sort-columns"
								i18n-label="@@subscription.simulator.queryParams.sortColumns">
							</app-multi-select-menu>

							<div class="remove-btn">
								<app-button
									*ngIf="vo.sortSelectedColumns.size !== 0"
									loaderSize="20"
									[leftIcon]="DcIcons.ResetSelection"
									(click)="removeAllSortSelectedColumns()"></app-button>
							</div>

							<div class="select-sort-columns"
									 [class.no-selection]="vo.sortSelectedColumns.size === 0"
									 (click)="vo.sortSelectedColumns.size === 0 && showColumnsToSortMultiSelectMenu($event)">
								<app-columns-configurator
									*ngIf="vo.sortSelectedColumns.size !== 0"
									(handleRemove)="sortColumnRemoved($event)"
									(handleColumnsOrderingChange)="sortColumnOrderModified($event)"
									(handleSortOrderChange)="sortOrderModified($event)"
									class="sort-columns-selection-chips"
									[elements]="vo.sortSelectedColumns | toArray"
									[viewMode]="'dragDrop'"
									[hasActiveSort]="true"></app-columns-configurator>
								<div
									*ngIf="vo.sortSelectedColumns.size === 0"
									class="sort-columns-selection-area"
									i18n="@@subscription.simulator.queryParams.sortColumns.no-selection">
									sort-columns-no-selection
								</div>
							</div>
						</div>

					</app-panel>
				</ng-container>

			</div>

			<div *ngIf="vo.simulationColumnList.elements.size !== 0" class="subscription-simulator-result">
				<div class="subscription-simulator-result-summary">
					<div class="data-source-selection">
						<label
							i18n="@@subscription.simulator.dataSource">
							data-source</label>
						<app-toggle-buttons
							id="datasource-type"
							[actions]="dataSourceType"></app-toggle-buttons>
					</div>

					<app-button
						class="simulation-test-btn"
						[attr.data-disabled]="vo.simulationColumnList.elements.size === 0 || vo.isSimulationLoading"
						[loaderSize]="15"
						[isInProgress]="vo.isSimulationLoading"
						[isDisabled]="vo.simulationColumnList.elements.size === 0 || vo.isSimulationLoading"
						id="subscription-simulation-test-btn"
						i18n="@@subscription.simulator.test.btn"
						(click)="simulationExec()">
						tester</app-button>

					<div *ngIf="vo.simulationResult">
						<h1 i18n="@@subscription.simulator.results-summary">results</h1>
						<div class="">
							<span i18n="@@subscription.simulator.results-total-hits">total</span>
							: <span>{{ vo.simulationResult.count }}</span>
						</div>
					</div>
				</div>

				<ng-container
					[ngTemplateOutlet]="simulationResult"
					[ngTemplateOutletContext]="{ columns: vo.simulationResultColumns, result: vo.simulationResult }">
				</ng-container>
			</div>
		</app-page-content>
	</app-page>
</ng-container>

<ng-template
	#simulationColumns
	let-columnList="columnList">
	<dx-data-grid
		keyExpr="id"
		[elementAttr]="{
			id: 'subscription-simulation-column-config',
			class: 'app-subscription-simulation-column-config'
		}"
		[repaintChangesOnly]="true"
		[dataSource]="columnList.elements | toArray"
		[hoverStateEnabled]="true"
		[showColumnHeaders]="true"
		[allowColumnResizing]="true"
		[columnAutoWidth]="false"
		[showRowLines]="false"
		[showColumnLines]="false"
		[rowAlternationEnabled]="false"
		[showBorders]="false"
		[width]="'100%'"
		[noDataText]="''">

		<dxo-scrolling mode="standard"></dxo-scrolling>
		<!-- Fixable in position columns	-->
		<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

		<dxo-load-panel
			shadingColor="rgba(0,0,0,0)"
			[indicatorSrc]="DcLoaders.LoaderInfinite"
			[height]="100"
			[width]="100"
			[enabled]="true"
			[showIndicator]="true"
			[showPane]="true"
			[shading]="true"></dxo-load-panel>


		<ng-container
			*ngFor="let col of columnList.availableColumns | toArray">
			<dxi-column
				*ngIf="col.field === 'label'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[allowEditing]="false"
				[visible]="col.visible"
				[width]="'25%'"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'alias'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[allowEditing]="false"
				[visible]="col.visible"
				[width]="'25%'"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'type'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[allowEditing]="false"
				[visible]="col.visible"
				[width]="60"
				cellTemplate="columnTypeTemplate"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'description'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[allowEditing]="false"
				[visible]="col.visible"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'isHashed'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[visible]="col.visible"
				[minWidth]="50"
				cellTemplate="hashedTemplate"></dxi-column>
		</ng-container>

		<div
			*dxTemplate="let cell of 'columnTypeTemplate'"
			class="column-type-template">
			<app-column-type
				[type]="cell.data['type']"
				[isList]="cell.data['isList']"></app-column-type>
		</div>

		<div *dxTemplate="let cell of 'hashedTemplate'">
			<mat-icon
				*ngIf="cell.data['isHashed']"
				class="is-hashed-column"
				[svgIcon]="DcIcons.Check"></mat-icon>
		</div>

		<dxo-paging [enabled]="false"></dxo-paging>

	</dx-data-grid>
</ng-template>

<ng-template #noData>
	<div class="no-data-template">
		<span
			i18n="@@subscription.simulator.column.no-data">
			no-selection</span>
	</div>
</ng-template>

<ng-template
	#simulationResult
	let-columns="columns"
	let-result="result">

	<dx-data-grid
		*ngIf="result !== null"
		[dataSource]="result.data"
		[hoverStateEnabled]="true"
		[allowColumnResizing]="true"
		[columnAutoWidth]="true"
		[showBorders]="true">
		<dxo-header-filter [visible]="true"></dxo-header-filter>
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-sorting mode="multiple"></dxo-sorting>
		<dxi-column
			*ngFor="let col of columns | toArray"
			[dataField]="col.alias"
			[caption]="col.alias"
			[dataType]="col.dxDataType"
			[sortOrder]="col.sortOrder"
			[sortIndex]="col.sortIndex"
			headerCellTemplate="headerTmpl">
		</dxi-column>

		<div
			class="dx-header-template"
			*dxTemplate="let data of 'headerTmpl'">
			<i>{{ data.column.caption }}</i>
			<app-column-type
				*ngIf="columns.get(data.column.caption) as simulationCol"
				[type]="simulationCol.type"
				[isList]="simulationCol.isList"></app-column-type>
		</div>

	</dx-data-grid>
</ng-template>
